export const LOGIN_PATH = '/login';
export const LOGIN_CALLBACK_PATH = '/login/callback';
export const LOGOUT_REDIRECTION_CALLBACK_PATH = '/logout/callback';
